import React, { useState, useEffect } from "react";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { deleteURLData } from "../../api";
import Loader from "../../component/Loader";
import DeleteModal from "../../component/Modal/Delete";
import Paginations from "../../component/Pagination";
import Select from "react-select";
import { FetchTermsConditions } from "./termsConditionsSlice";

function TermsConditionsList({
  tcType = "admin",
  listPath = "/terms-and-conditions",
  addPath = "/add/terms-and-conditions",
  editPath = "/edit/terms-and-conditions",
}) {
  const dispatch = useDispatch();
  const authState = useSelector((state) => state.auth);
  const isPlatformSuperAdmin =
    authState?.user_type?.toLowerCase() === "super_admin";
  const showCompanyFilter = tcType === "company" && isPlatformSuperAdmin;

  const [loading, setLoading] = useState(false);
  const [delId, setDelId] = useState("");
  const [show, setShow] = useState(false);
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState("");
  const list = useSelector((state) => state.termsConditions.list);
  const total = useSelector((state) => state.termsConditions.total);

  let companyOptions = [];
  const companiesStr = localStorage.getItem("companies");
  if (companiesStr) {
    try {
      const companies = JSON.parse(companiesStr);
      if (Array.isArray(companies) && companies.length > 0) {
        companyOptions = [
          { value: 0, label: "All Companies" },
          ...companies.map((c) => ({
            value: c.id,
            label: c.company_name,
          })),
        ];
      }
    } catch (e) {
      companyOptions = [];
    }
  }
  const [selectedCompany, setSelectedCompany] = useState(0);

  const getCompanyName = (companyId) => {
    const company = companyOptions.find((c) => c.value === companyId);
    return company?.label || companyId || "NA";
  };

  const handlePage = (val) => {
    setPage(val);
  };

  const handleShow = () => {
    setShow(!show);
  };

  const fetchList = () => {
    setLoading(true);
    const params = { page, limit: 10, search, tc_type: tcType };
    if (showCompanyFilter && selectedCompany > 0) {
      params.company_id = selectedCompany;
    }
    return dispatch(FetchTermsConditions(params)).then(() => setLoading(false));
  };

  useEffect(() => {
    setLoading(true);
    const params = { page, limit: 10, search, tc_type: tcType };
    if (showCompanyFilter && selectedCompany > 0) {
      params.company_id = selectedCompany;
    }
    dispatch(FetchTermsConditions(params)).then(() => setLoading(false));
  }, [dispatch, page, search, selectedCompany, tcType, showCompanyFilter]);

  const confirmDelete = () => {
    deleteURLData(`admin/removeTermsConditions/${delId}`).then((res) => {
      if (res?.code === 1) {
        toast.success(res?.message, { autoClose: false, closeButton: true });
        handleShow();
        fetchList();
      } else {
        toast.error(res?.message, { autoClose: false, closeButton: true });
      }
    });
  };

  return (
    <article className="col-lg-9 articleClass">
      <div className="article-body store-bd-gy">
        <div className="row align-items-center col-rever">
          <div className="col-sm-12 col-md-6 col-lg-6 mb-3">
            <div className="link-active shadow">
              <p>
                <img src="assets/images/users-selected.png" alt="" /> Total T&Cs{" "}
                {total}
              </p>
            </div>
          </div>
          <div className="col-sm-12 col-md-6 col-lg-6 mb-3">
            <div className="d-flex align-items-center lg-justify-content-end">
              <form className="has-search">
                <span className="form-search-icon form-control-feedback"></span>
                <input
                  type="text"
                  className="form-control shadow"
                  placeholder="Search by version"
                  value={search}
                  onChange={(e) => {
                    setPage(1);
                    setSearch(e.target.value);
                  }}
                />
              </form>
              <Link to={addPath} className="">
                <img
                  src="assets/images/addBtn.png"
                  alt=""
                  className="add-new"
                />
              </Link>
            </div>
          </div>
        </div>
        {showCompanyFilter && companyOptions.length > 0 && (
          <div className="row mb-3">
            <div className="col-sm-12 col-md-12 col-lg-4">
              <Select
                options={companyOptions}
                isSearchable
                placeholder="Select a company..."
                value={companyOptions.find(
                  (option) => option.value === selectedCompany
                )}
                onChange={(option) => {
                  setPage(1);
                  setSelectedCompany(option.value);
                }}
              />
            </div>
          </div>
        )}
        <div className="row mt-1">
          <div className="col-sm-12">
            <div className="table-responsive text-center">
              <table className="table storetable">
                <thead className="text-center">
                  <tr>
                    <th scope="col">ID</th>
                    {showCompanyFilter && <th scope="col">Company</th>}
                    <th scope="col">Version</th>
                    <th scope="col">Content Type</th>
                    <th scope="col">Created At</th>
                    <th scope="col">Action</th>
                  </tr>
                  <tr className="border-0 bg-none invisible">
                    <td className="border-0 bg-none"></td>
                  </tr>
                </thead>
                <tbody>
                  {loading ? (
                    <tr>
                      <td colSpan={showCompanyFilter ? 6 : 5}>
                        <Loader />
                      </td>
                    </tr>
                  ) : (
                    <>
                      {list?.length > 0 ? (
                        list.map((item) => (
                          <tr key={item.id}>
                            <td>{item?.id || "NA"}</td>
                            {showCompanyFilter && (
                              <td>{getCompanyName(item?.company_id)}</td>
                            )}
                            <td>{item?.version || "NA"}</td>
                            <td>{item?.pdf ? "PDF" : "Editor"}</td>
                            <td>
                              {item?.created_at
                                ? moment
                                    .unix(item.created_at)
                                    .format("DD MMM YYYY")
                                : "NA"}
                            </td>
                            <td>
                              <div className="d-flex justify-content-center action align-items-center">
                                {item?.pdf && (
                                  <button className="btn" title="View PDF">
                                    <a
                                      href={item.pdf}
                                      target="_blank"
                                      rel="noreferrer"
                                      className="cursor-pointer"
                                    >
                                      <img
                                        src="assets/images/downloadActive.png"
                                        alt=""
                                      />
                                    </a>
                                  </button>
                                )}
                                <button className="btn">
                                  <Link to={`${editPath}/${item?.id}`}>
                                    <img
                                      src="assets/images/edit.png"
                                      alt=""
                                    />
                                  </Link>
                                </button>
                                <button
                                  className="btn"
                                  onClick={() => {
                                    setDelId(item.id);
                                    handleShow();
                                  }}
                                  title="Delete"
                                >
                                  <img
                                    src="assets/images/delete.png"
                                    alt=""
                                  />
                                </button>
                              </div>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan={showCompanyFilter ? 6 : 5}>
                            No data found.
                          </td>
                        </tr>
                      )}
                    </>
                  )}
                </tbody>
              </table>
            </div>
          </div>
          {list?.length > 0 && (
            <Paginations
              handlePage={handlePage}
              page={page}
              total={total && total}
            />
          )}
        </div>
      </div>

      <DeleteModal
        page="Terms and Condition"
        show={show}
        handleShow={handleShow}
        cancel={() => {
          setShow(false);
        }}
        confirmDelete={confirmDelete}
      />
    </article>
  );
}

export default TermsConditionsList;
